import React, { useContext } from "react";
import Grid from "@material-ui/core/Grid";
import clsx from 'clsx';
import Typography from "@material-ui/core/Typography";

import SurveyQuestionContext from "../../../context/surveyquestion-context";
import { ProgressBarQuestion } from "../../shared/component";

import useStyles from "../../../styles/components/survey/stylesSurveyQuestionContainer";

const ScaleQuestionHolder = ({ index }) => {
  const classes = useStyles();
  const { surveyQuestionContext } = useContext(SurveyQuestionContext);

  return (
    <>
      {surveyQuestionContext.scaleContents.length > 0 && (
          <>
            <Typography
              variant="h6"
              className={clsx(classes.rootTypographyQuestion, classes.typographyDown)}
            >
              {surveyQuestionContext.header}
            </Typography>
            <Typography variant="h6" classes={{ root: classes.typographyDown }}>
              {surveyQuestionContext.scaleContents[index].question.questionContent}
            </Typography>
            <Grid container justify="center">
              <ProgressBarQuestion
                marks={surveyQuestionContext.scaleContents[index].answers}
                index={index}
              />
            </Grid>
          </>
        )
      }
    </>
  );
};

export default ScaleQuestionHolder;
